import React from "react";
import {Row, Col, Form, Input, Select} from 'antd';


const { TextArea } = Input;
const {Option} = Select;

const TabNucardapio = ({dataTab})=> {

    
    return (
        <Row gutter={[16, 16]}>
           
           <Col span={4}>
                <Form.Item label="Exibe no Nucardapio?" name="nucardapio">
                    <Select data-tab={dataTab}>
                        <Option value={1}>SIM</Option>
                        <Option value={0}>NAO</Option>
                    </Select>
                </Form.Item>
            </Col>
            
            
            <Col sm={16}>
                <Form.Item label="Link da Foto" name="linkFoto">
                    <Input data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col sm={4}>
                <Form.Item label="Ordem" name="ordem">
                    <Input data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col sm={24}>
                <Form.Item label="Configurações" name="configuracoes">
                    <TextArea data-tab={dataTab} rows={5} />
                </Form.Item>
            </Col>
            
            
        </Row>
    );
}

export {TabNucardapio};